import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=7709a458&"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js&"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7709a458')) {
      api.createRecord('7709a458', component.options)
    } else {
      api.reload('7709a458', component.options)
    }
    module.hot.accept("./ToggleSwitch.vue?vue&type=template&id=7709a458&", function () {
      api.rerender('7709a458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/ToggleSwitch.vue"
export default component.exports